import { Manager } from "../../core";

export interface TeamAdmResponse {
	id: number;
	name: string;
	createdAt: string;
}

export interface ComboTeamAdmResponse {
	id?: number;
	comboId: number;
	cleaningDate: string;
	teamId: number;
	teamName?: string;
	createdAt?: string;
}

export const getTeams = async () => {
	try {
		const {data} = await Manager.request('get', '/admin/team/list.php');
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.team.get', err);
	}
}

export const getComboTeams = async () => {
    // Busca TODOS os agendamentos de equipes globais para preencher a store
	try {
		const {data} = await Manager.request('get', '/admin/combo-team/list.php');
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.comboTeam.get', err);
	}
}

export const assignTeam = async (comboId: number, cleaningDate: string, teamId: number) => {
	try {
		const {data} = await Manager.request('post', '/admin/combo-team/assign.php', {
            comboId,
            cleaningDate,
            teamId
        });
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.comboTeam.assign', err);
	}
}
